// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__FkL_y","insightsList":"newBusinessInsightsMenu_insightsList__GHW9D","active":"newBusinessInsightsMenu_active__2Z2i8"};